module.exports = __webpack_public_path__ + "img/firecrackers.7e360f8a.gif";